import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
export const ContinueSessionSchema = z
    .object({
    type: z.literal('session'),
    sessionType: z.enum(['learn', 'revise']),
    title: z.string(),
    progressPct: z.number(),
    lessonId: z.string().uuid().nullable(),
    courseId: z.string().uuid().nullable(),
    folderSlug: z.string().nullable(),
})
    .openapi('ContinueSession');
export const ContinueNoneSchema = z
    .object({
    type: z.literal('none'),
})
    .openapi('ContinueNone');
export const ContinueResponseSchema = z
    .discriminatedUnion('type', [ContinueSessionSchema, ContinueNoneSchema])
    .openapi('ContinueResponse');
//# sourceMappingURL=continue.schema.js.map